// extracted by mini-css-extract-plugin
export default {"dropDown":"SearchResult_dropDown__5EiBU"};